import React from "react";
import { Consumer, AuthenticationProviderInterface } from "./Context";

type WithAuthProps<P> = Omit<P, "auth">;

export default function withAuth<P extends object>(
    WrappedComponent: React.ComponentType<P & { auth: AuthenticationProviderInterface }>
): React.FC<WithAuthProps<P>> {
    return (props: WithAuthProps<P>) => (
        <Consumer>{(auth) => <WrappedComponent {...(props as P)} auth={auth} />}</Consumer>
    );
}
